import { InjectionToken } from '@angular/core';

/** Draft bloc key of the block instance currently rendered in CB2 preview. */
export const CB2_PREVIEW_BLOC_KEY = new InjectionToken<string | null>('CB2_PREVIEW_BLOC_KEY', {
  factory: () => null,
});
